import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { useComponentDidMount } from 'modules/core/hooks';
import { CheckboxInput, StringInput } from 'modules/core/components/forms';
import { FormModal } from 'modules/core/containers';

import * as actions from './store/actions';
import { ClientNotificationsControlRequest } from './api/notificationsApi';
import { clientNotificationsActions } from './store/notificationsStore';
import { notificationsControlValidationSchema } from './validation';

interface NotificationsControlModalProps {
  show: boolean,
  clientId: string,
  client?: Record<string, unknown>,
  getClient?: Function,
  onClose?: (...args: unknown[]) => unknown,
}

const NotificationsControlModal = (props: NotificationsControlModalProps) => {
  const {
    show,
    clientId,
    client,
    getClient,
    onClose,
  } = props;

  useComponentDidMount(() => {
    if (clientId && !client) {
      getClient(clientId);
    }
  });

  const handleSubmit = async (values: ClientNotificationsControlRequest, form: any) => {
    try {
      await clientNotificationsActions.updateNotificationsControl({
        clientId: values.clientId,
        canGetOrderStatusPush: values.canGetOrderStatusPush,
        canGetPenaltyPush: values.canGetPenaltyPush,
        canGetPenaltyEmail: values.canGetPenaltyEmail,
        canGetReceipt: values.canGetReceipt,
        canGetNews: values.canGetNews,
        reason: values.reason,
      });

      await clientNotificationsActions.clearError();
      await getClient(client.id);

      form.resetForm();
      if (typeof onClose === 'function') {
        onClose();
      }
    } finally {
      form.setSubmitting(false);
    }
  };

  return (
    // @ts-ignore
    <FormModal
      show={ show }
      header='Настройка уведомлений'
      initialValues={ { clientId: client.id, ...client } }
      validationSchema={ notificationsControlValidationSchema }
      onClose={ onClose }
      onCancel={ onClose }
      onSubmit={ handleSubmit }
    >
      { ({ dirty }) => (
        <>
          <Row>
            <Col lg={ 12 }>
              <CheckboxInput
                // @ts-ignore
                name='canGetOrderStatusPush'
                label='Изменение статусов заявки (push-уведомление в мобильное приложение клиента)'
              />
            </Col>
          </Row>
          <Row>
            <Col lg={ 12 }>
              <CheckboxInput
                // @ts-ignore
                name='canGetPenaltyPush'
                label='Наличие штрафов ПДД (push-уведомление в мобильное приложение клиента)'
              />
            </Col>
          </Row>
          <Row>
            <Col lg={ 12 }>
              <CheckboxInput
                // @ts-ignore
                name='canGetPenaltyEmail'
                label='Наличие штрафов ПДД (письмо на email клиента)'
              />
            </Col>
          </Row>
          <Row>
            <Col lg={ 12 }>
              <CheckboxInput
                // @ts-ignore
                name='canGetNews'
                label='Новости'
              />
            </Col>
          </Row>
          <Row>
            <Col lg={ 12 }>
              <CheckboxInput
                // @ts-ignore
                name='canGetReceipt'
                label='Получать чеки'
              />
            </Col>
          </Row>
          <Row>
            <Col lg={ 12 }>
              <StringInput
                // @ts-ignore
                name='reason'
                label='Причина изменения настроек'
                as='textarea'
                rows={ 3 }
                disabled={ !dirty }
              />
            </Col>
          </Row>
        </>
      ) }
    </FormModal>
  );
};

const mapStateToProps = (state) => {
  return {
    client: state.clients?.item,
  };
};

const mapDispatchToProps = {
  getClient: actions.getClientInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsControlModal);
